"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));
var _isNull2 = _interopRequireDefault(require("lodash/isNull"));
var _find2 = _interopRequireDefault(require("lodash/find"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// refactor for fidelity score
var _default = exports["default"] = function _default(settings) {
  var classname = '';
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    var noValue = false;
    if ((0, _isNull2["default"])(value) || (0, _isUndefined2["default"])(value)) {
      noValue = true;
    }
    var iconItem = (0, _find2["default"])(settings.status, function (item) {
      return Math.round(value) >= parseInt(item.min, 10) && Math.round(value) <= parseInt(item.max, 10);
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: row,
      className: "".concat(classname, " ").concat(_style["default"].iconContainer, " text-center")
    }, !noValue ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("svg", {
      color: iconItem.icon.color,
      className: _style["default"].icon,
      xmins: "http://www.w3.org/2000/svg",
      viewBox: iconItem.icon.viewBox,
      width: "20",
      height: "20"
    }, /*#__PURE__*/_react["default"].createElement("g", null, iconItem.icon.paths.map(function (p) {
      return /*#__PURE__*/_react["default"].createElement("path", {
        key: p,
        d: p
      });
    })))), "  ".concat(settings.prefix).concat(Math.round(value)).concat(settings.suffix)) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-center"
    }));
  };
};